export enum NOTIFICATION_MESSAGE_TYPES {
  ADMIN_CARONPLACE_PUSH = "13",
  ADMIN_CANCEL_RESERVATION = "12",
  ADMIN_OVER_RESERVATION = "11",
  ADMIN_RECIEVED_NEW_RES = "10",
  RESERVATIONS_UPDATE = "9",
  CAR_ON_PLACE = "8",
}
